import { FC } from 'react';
import { MdPerson } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { TSTitleCard } from '../../../../components/shared/card/Card';
import { Feature } from '../../../../services/backstage/Feature';
import { ReadEmployee } from '../../../../services/gql/graphql.generated';
import strings from '../../team.translations';
import { TeamMemberLocations } from './TeamMemberLocations';

interface TeamMemberCardProps {
  enableEdit?: boolean;
  employee: ReadEmployee;
}

export const TeamMemberCard: FC<TeamMemberCardProps> = ({ employee, enableEdit }) => {
  const navigate = useNavigate();
  const onEditClick = () => {
    navigate(`/team-member/${employee.identityId}/edit-details`);
  };

  return (
    <TSTitleCard
      title={strings.cardTitle}
      icon={MdPerson}
      primaryAction={
        enableEdit
          ? {
              label: strings.editTeamMember.editLabel,
              onClick: onEditClick
            }
          : undefined
      }
    >
      <div className="flex flex-col gap-4 pt-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <div className="font-semibold">{strings.common.firstName}</div>
            <div>{employee.firstName ?? '-'}</div>
          </div>
          <div>
            <div className="font-semibold">{strings.common.lastName}</div>
            <div>{employee.lastName ?? '-'}</div>
          </div>
        </div>
        <div className="grid break-all grid-cols-1 gap-4">
          {employee.employeeId && (
            <div>
              <div className="font-semibold">{strings.common.organizationId}</div>
              <div>{employee.employeeId}</div>
            </div>
          )}
          {employee.email && (
            <div>
              <div className="font-semibold">{strings.common.email}</div>
              <div className="text-blue-400 hover:text-purple-600">
                <a href={'mailto:' + employee.email}>{employee.email}</a>
              </div>
            </div>
          )}
          {employee.phoneNumber && (
            <div>
              <div className="font-semibold">{strings.common.phoneNumber}</div>
              <div className="text-blue-400 hover:text-purple-600">
                <a href={'tel:' + employee.phoneNumber}>{employee.phoneNumber}</a>
              </div>
            </div>
          )}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <div className="font-semibold">{strings.role}</div>
            <div>{employee.role}</div>
          </div>
        </div>
        <Feature name="devices">
          <TeamMemberLocations employee={employee} />
        </Feature>
      </div>
    </TSTitleCard>
  );
};
